export default {
  id: "vrc-hired-eku",
  pride: 18432,
  slug: "vrc-hired-eku",
  category: ["video", "vrchat"],
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "【VRChat】我雇了一只Eku来盯着你",
    en: "[VRChat] I Hired an Eku to Watch You"
  },
  bilibiliVideoId: "BV1kj4uz2ERG",
  descriptionKey: {
    zh: "模型展示视频，纯可爱向。1万播放。",
    en: "A model showcase video. Pure cuteness. 10k views."
  },
  date: { year: 2025, month: 10, day: 12 },
  genres: ["模型展示", "VRChat日常"],
  themes: ["可爱", "VRChat"],
  achievements: [
    { zh: "B站 1 万播放", en: "10k views on Bilibili" }
  ],
  developerNotesKey: {
    zh: "Eku 模型展示，纯可爱向，没想到能有1万播放。",
    en: "Eku model showcase, pure cuteness — didn't expect 10k views."
  },
  tags: ["VRChat"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1kj4uz2ERG/", textKey: { zh: "B站观看", en: "Watch on Bilibili" } }
  ]
};
